/**
 *
 * @param {*} potentialObject - The thing you want to test to see if it's an object
 * @returns True if the potentialObject has the typeof 'object' and it's not an array and it's not null
 */
const jsonStringifyWithFunctions = (obj) => {
	return JSON.stringify(obj, (key, val) => {
		return typeof val === 'function' ? val.toString() : val;
	});
};

export default jsonStringifyWithFunctions;
